<template>
    <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10">
        <!-- Header Section -->
        <div class="d-flex align-center py-5 mb-6 animate-fade-in-up stagger-1" style="border-bottom: 1px solid rgba(255, 255, 255, 0.08);">
            <v-btn class="premium-btn-icon-circle mr-4" icon @click="$router.push('/shop')">
                <v-icon color="white">mdi-chevron-left</v-icon>
            </v-btn>
            <h1 class="premium-title-gradient text-h5 font-weight-black mb-0">Personalisierung</h1>
        </div>

        <v-form 
            @submit.prevent 
            ref="shopCheckoutForm" 
            class="ma-auto animate-fade-in-up stagger-2" 
            style="max-width: 800px" 
            lazy-validation
            novalidate
        >
            <div v-for="(product, index) in mappedCartProducts" :key="product.title + index" class="glass-card pa-6 mb-6 d-block" dark>
                <!-- Product Preview Row -->
                <v-row no-gutters class="align-center mb-6">
                    <v-col cols="8" class="pr-4">
                        <h2 class="text-h6 font-weight-bold white--text mb-1">{{ product.title }}</h2>
                        <p class="grey--text text--lighten-1 text-subtitle-2 mb-0" style="line-height: 1.4;">{{ product.shortDescription }}</p>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-end">
                        <v-img :aspect-ratio="1.6" class="rounded-xl elevation-3" max-width="150" :src="'/img/' + product.picture"></v-img>
                    </v-col>
                </v-row>

                <v-divider style="background-color: rgba(255, 255, 255, 0.08)" class="mb-5"></v-divider>

                <!-- Personalisation Fields -->
                <h3 class="text-subtitle-1 font-weight-bold white--text mb-4">Für wen ist dieses Produkt?</h3>
                
                <v-row>
                    <v-col cols="12" sm="6" class="py-1">
                        <v-text-field 
                            label="Vorname" 
                            filled 
                            rounded 
                            dark
                            :rules="rules.required"
                            class="premium-input"
                            v-model="productPersonalisations[index].prename"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-1">
                        <v-text-field 
                            label="Nachname" 
                            filled 
                            rounded 
                            dark
                            :rules="rules.required"
                            class="premium-input"
                            v-model="productPersonalisations[index].lastname"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-1">
                        <v-textarea 
                            filled 
                            rounded 
                            dark
                            label="Text auf dem Gutschein" 
                            :rules="rules.required"
                            counter="550" 
                            class="premium-input"
                            rows="4"
                            v-model="productPersonalisations[index].text"
                        ></v-textarea>
                    </v-col>
                </v-row>

                <v-divider style="background-color: rgba(255, 255, 255, 0.08)" class="my-4"></v-divider>

                <!-- Item Footer Actions -->
                <v-row no-gutters class="align-center justify-space-between pt-2">
                    <v-col cols="7" class="d-flex justify-start">
                        <v-btn 
                            @click="createTestPrintversion(product, index)" 
                            class="premium-btn-outline px-5 py-4"
                            small
                        >
                            Beispiel Ausdruck
                            <v-icon right size="16">mdi-eye-outline</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="5" class="d-flex justify-end">
                        <span style="color: #00B074; font-weight: 900; font-size: 1.5rem;">
                            CHF {{ product.price }}.-
                        </span>
                    </v-col>
                </v-row>
            </div>
        </v-form>

        <!-- Dynamic checkout total and CTA button -->
        <div class="d-flex flex-column align-center justify-center my-10 animate-fade-in-up stagger-3">
            <p class="grey--text text--lighten-2 text-subtitle-1 mb-2">Gesamtsumme der Bestellung</p>
            <div class="white--text text-h4 font-weight-black mb-5" style="color: #00B074 !important;">{{ cartTotalPrice }} CHF</div>
            
            <v-btn 
                class="premium-btn py-7 px-12 text-h6 font-weight-bold" 
                x-large
                @click="buyProducts()"
            >
                <v-icon left>mdi-credit-card-check-outline</v-icon>
                Jetzt sicher kaufen
            </v-btn>
        </div>

        <v-dialog style="overflow: hidden;" @click:outside="paymentInitiated = false" v-model="paymentInitiated" persistent>
            <payment-dialog 
                @completed="adyenPaymentCompleted" 
                :amount="paymentAmount" 
                :resortID="paymentResortID"
                :studio="paymentStudio" 
                :purchaseID="purchaseID" 
                :profileID="profileID"
                v-if="paymentInitiated"
            ></payment-dialog>
        </v-dialog>
    </div>
</template>

<script>
import api from '../../api'
import { mapGetters, mapActions, mapState } from 'vuex'
import PaymentDialog from "../payment/paymentDialog.vue";

export default {
    beforeDestroy() {
        //window.removeEventListener('beforeunload', this.preventPageReload)
    },
    components: {
        PaymentDialog
    },
    data() {
        return {
            productPersonalisations: [],
            paymentInitiated: false,
            purchaseID: null,
            profileID: null,
            paymentAmount: null,
            paymentStudio: '5f326a24ae8863640c859e75',
            paymentResortID: '1',
            drawer: false,
            products: [],
            rules: {
                required: [(v) => !!v || 'Dieses Feld ist erforderlich'],
                maxLength750: [(v) => v.length <= 550 || 'Nicht mehr als 550 Zeichen'],
            },
        }
    },
    async created() {
        //window.addEventListener('beforeunload', this.preventPageReload)

        if (!this.cartProducts.length) this.$router.push('/shop')
        let amount = this.cartProducts.reduce((a, b) => a + b.amount, 0)
        for (let i = 0; i < amount; i++) {
            this.productPersonalisations.push({ prename: '', lastname: '', text: '' })
        }
    },
    computed: {
        ...mapState('shopStore', ['cartVisibilityToggle', 'cartProducts']),
        ...mapGetters('shopStore', ['cartTotalPrice']),
        mappedCartProducts() {
            let mappedProducts = []
            this.cartProducts.forEach((product) => {
                for (let i = 0; i < product.amount; i++) {
                    mappedProducts.push(product)
                }
            })
            return mappedProducts
        },
    },
    methods: {
        ...mapActions('shopStore', ['addProductToCart', 'removeProductFromCart', 'openProductFromStore']),
        /*    preventPageReload(event) {
                // Check if the dialog is open, and if so, prevent the page reload
    
                event.preventDefault()
                event.returnValue = ''
            },*/
        async createTestPrintversion(product, index) {
            if (
                this.productPersonalisations[index].prename &&
                this.productPersonalisations[index].lastname &&
                this.productPersonalisations[index].text
            ) {
                await api.productExamplePrintVersion({ ...product, ...this.productPersonalisations[index] })
            } else {
                this.$toast.error('Fülle alle Felder aus')
            }
        },
        async buyProducts() {
            if (!this.$refs.shopCheckoutForm.validate()) {
                this.$toast.error('Fülle alle Felder aus.')
                return
            }
            let preparedProducts = this.cartProducts.map((product, index) => {
                return {
                    ...product,
                    personalization: this.productPersonalisations[index],
                }
            })
            let createdPayment = await api.createProductPayment(preparedProducts)
            this.paymentAmount = createdPayment.amount
            this.purchaseID = createdPayment._id

            this.paymentInitiated = true
        },
        openProduct(id) {
            this.openProductFromStore(id)
        },
    },
    watch: {
        cartVisibilityToggle() {
            this.drawer = true
        },
    },
}
</script>

<style>
@import './shopCommon.css';
</style>